var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #291f17;\n            }\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wm_Prancheta 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.5,15a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7l14-14a.48.48,0,0,1,.7,0,.48.48,0,0,1,0,.7l-14,14A.47.47,0,0,1,.5,15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.5,15a.47.47,0,0,1-.35-.15L.15.85a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0l14,14a.48.48,0,0,1,0,.7A.47.47,0,0,1,14.5,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0b3def3c1884dfbf43bde2a7ab60f699.svg";
export { ForwardRef as ReactComponent };